import styled from "styled-components";

export const StyledApp = styled.div``;

export const StyledMainContainer = styled.div`
  min-height: 68vh;
`;
